import React from "react";
import { Modal } from "antd";

const TedModal = ({
  open,
  setOpen,
  header,
  footer,
  content,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
  header?: React.ReactNode;
  footer?: React.ReactNode;
  content?: React.ReactNode;
}) => {
  const handleCancel = () => {
    setOpen(false);
  };

  return (
    <Modal
      width={"684px"}
      open={open}
      onCancel={handleCancel}
      title={header} // Setting the modal's header
      footer={footer} // Setting the modal's footer
    >
      {content} {/* Render the modal content */}
    </Modal>
  );
};

export default TedModal;
